export default "__VITE_ASSET__Cl$hBwvQ__"